var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToGulekort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1588,
    cy: 13.8408,
    r: 13.3408,
    fill: "#F9F9F9",
    stroke: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2358 19.2874L11.4852 17.6726C11.5837 17.5451 11.553 17.3563 11.4165 17.2506L7.95616 14.5735C7.81965 14.4679 7.62909 14.4856 7.53052 14.613L6.2812 16.2278",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43664 14.9453C9.49142 8.98563 7.87493 10.5929 14.7954 7.26554",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4845 16.4978L15.0787 18.4135C15.2989 18.6761 15.6821 18.7284 15.9364 18.5305L21.4775 14.2068C21.7307 14.0073 21.7582 13.633 21.5391 13.3694L19.6923 11.1499",
    fill: "#FDC033"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4845 16.4978L15.0787 18.4135C15.2989 18.6761 15.6821 18.7284 15.9364 18.5305L21.4775 14.2068C21.7307 14.0073 21.7582 13.633 21.5391 13.3694L19.6923 11.1499",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8651 15.4574L14.9314 16.2823C15.0625 16.3837 15.2258 16.4324 15.3854 16.4176C15.5451 16.4028 15.688 16.3258 15.7826 16.2034L20.066 10.6669C20.2631 10.4121 20.2016 10.0343 19.9286 9.82307L15.974 6.76353C15.701 6.55231 15.3198 6.58765 15.1227 6.84246L10.8393 12.379C10.6994 12.5598 10.617 12.8818 10.9144 12.9275L13.6276 11.4245C14.4411 10.9572 15.2041 12.3079 14.3902 12.7756C13.9004 13.0634 13.4491 13.407 13.0448 13.7998C12.838 14.6627 12.441 15.4591 11.8807 16.1348L11.1668 17.0575",
    fill: "#D52B1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8651 15.4574L14.9314 16.2823C15.0625 16.3837 15.2258 16.4324 15.3854 16.4176C15.5451 16.4028 15.688 16.3258 15.7826 16.2034L20.066 10.6669C20.2631 10.4121 20.2016 10.0343 19.9286 9.82307L15.974 6.76353C15.701 6.55231 15.3198 6.58765 15.1227 6.84246L10.8393 12.379C10.6994 12.5598 10.617 12.8818 10.9144 12.9275L13.6276 11.4245C14.4411 10.9572 15.2041 12.3079 14.3902 12.7756C13.9004 13.0634 13.4491 13.407 13.0448 13.7998C12.838 14.6627 12.441 15.4591 11.8807 16.1348L11.1668 17.0575",
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToGulekort);
export default __webpack_public_path__ + "static/media/to_gulekort.6b8268d1183d5d79deedabce64e8179d.svg";
export { ForwardRef as ReactComponent };